import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "cp-theme";

const getInitialDarkMode = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored !== null) return stored === "dark";
    } catch (e) {
        // localStorage indisponível (ex.: modo privado) — segue o sistema
    }
    return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ?? false;
};

const persist = (isDarkMode) => {
    try {
        localStorage.setItem(STORAGE_KEY, isDarkMode ? "dark" : "light");
    } catch (e) {
        // best-effort: sem persistência, o tema ainda funciona na sessão
    }
};

const themeSlice = createSlice({
    name: "theme",
    initialState: {
        isDarkMode: getInitialDarkMode(),
    },
    reducers: {
        toggleTheme: (state) => {
            state.isDarkMode = !state.isDarkMode;
            persist(state.isDarkMode);
        },
        setDarkMode: (state, action) => {
            state.isDarkMode = Boolean(action.payload);
            persist(state.isDarkMode);
        },
    },
});

export const { toggleTheme, setDarkMode } = themeSlice.actions;
export default themeSlice.reducer;
